export default __webpack_public_path__ + "static/media/about-grid-05.398c836b.jpg";